<script lang="ts">
import { defineComponent } from 'vue'

import HeaderButton from '@mobile/components/HeaderButton/HeaderButton.vue'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import { useSportConfiguration } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/useSportConfiguration'

export default defineComponent({
  components: { HeaderButton },
  setup() {
    // composable
    const {
      probableEvent: {
        value: { id: eventId },
      },
    } = useEventInjections()
    const {
      eventHeaderConfiguration: { isSportSupportedByDesktopVersion },
    } = useSportConfiguration()

    // data
    const { VITE_COLLECTOR_DESKTOP_URL, VITE_SPORTSADMIN_PROTOCOL } =
      import.meta.env
    const protocolURL = isSportSupportedByDesktopVersion
      ? `${VITE_COLLECTOR_DESKTOP_URL}/relation/${eventId}`
      : `${VITE_SPORTSADMIN_PROTOCOL}${eventId}?ws=yes`

    return { protocolURL }
  },
})
</script>

<template>
  <HeaderButton
    link
    :to="protocolURL"
    target="_blank"
  >
    Protocol
  </HeaderButton>
</template>
